import React, { useEffect } from 'react';

function PaymentMethodsPage({ onBack, userProfile }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const paymentMethods = [
    {
      id: 'tron',
      name: 'TRON (TRC20)',
      icon: 'bi-currency-bitcoin',
      description: 'Network fee: ~1 USDT',
      status: 'Active',
      details: userProfile?.paymentMethods?.tron || 'Not configured'
    },
    {
      id: 'ethereum',
      name: 'Ethereum (ERC20)',
      icon: 'bi-currency-bitcoin',
      description: 'Network fee: ~5 USDT',
      status: 'Active',
      details: userProfile?.paymentMethods?.ethereum || 'Not configured'
    },
    {
      id: 'bitcoin',
      name: 'Bitcoin (BTC)',
      icon: 'bi-currency-bitcoin',
      description: 'Network fee: ~0.0001 BTC',
      status: 'Active',
      details: userProfile?.paymentMethods?.bitcoin || 'Not configured'
    }
  ];

  const handlePaymentMethodClick = (methodId) => {
    // Handle payment method configuration
    console.log('Configure payment method:', methodId);
    // You can add a modal or navigate to a configuration page here
  };

  return (
    <div className="personal-info-page">
      {/* Top Navigation Bar */}
      <div className="personal-info-top-bar">
        <div className="personal-info-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="personal-info-title-text">Payment Methods</div>
        <div className="personal-info-spacer"></div>
      </div>

      {/* Main Content */}
      <div className="personal-info-content">
        {/* Payment Methods Card */}
        <div className="personal-info-card">
          {paymentMethods.map((method, index) => (
            <React.Fragment key={method.id}>
              <div 
                className="personal-info-row clickable"
                onClick={() => handlePaymentMethodClick(method.id)}
              >
                <div className="d-flex align-items-center" style={{ flex: 1 }}>
                  <div className="personal-info-row-icon" style={{ marginRight: '12px', fontSize: '24px', color: '#6f42c1' }}>
                    <i className={`bi ${method.icon}`}></i>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="personal-info-row-label" style={{ fontWeight: '500' }}>{method.name}</div>
                    <div style={{ fontSize: '0.85rem', color: '#6c757d', marginTop: '2px' }}>{method.description}</div>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div style={{ marginRight: '12px', fontSize: '0.85rem', color: '#28a745' }}>
                    {method.status}
                  </div>
                  <div className="personal-info-row-arrow">
                    <i className="bi bi-chevron-right"></i>
                  </div>
                </div>
              </div>
              {index < paymentMethods.length - 1 && <div className="personal-info-divider"></div>}
            </React.Fragment>
          ))}
        </div>

        {/* Info Card */}
        <div className="personal-info-card" style={{ marginTop: '16px' }}>
          <div className="personal-info-row">
            <div className="personal-info-row-label" style={{ fontSize: '0.9rem', color: '#6c757d' }}>
              <i className="bi bi-info-circle me-2" style={{ color: '#6f42c1' }}></i>
              Configure your payment methods to enable deposits and withdrawals
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentMethodsPage;

